import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { SpeciesViewModel, SPECIES_DISPLAY_FIELD } from './+state';
import { SpeciesConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = SpeciesConstants;

@Injectable({providedIn: 'root'})
export class SpeciesService extends BaseService<SpeciesViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Species', RT.defaultApi)), SPECIES_DISPLAY_FIELD);
  }
}
